import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { screenForPath, screenForTab } from '../v2/shell/nav';
import { recordActivity } from '../services/engagement';

const AREAS = { organizations: 'organizations', upload: 'snapshot', downloads: 'snapshot', scan: 'external_scans',
  prospecting: 'prospecting', 'scan-links': 'scan_links', 'lead-magnet': 'lead_magnets', widgets: 'lead_magnets',
  templates: 'reports', 'review-overview': 'reviews', assessments: 'reviews', 'review-schedule': 'reviews',
  'review-templates': 'reviews', 'reviews-scans': 'reviews', integrations: 'integrations',
  administration: 'administration', profile: 'administration', 'two-factor': 'administration',
  requests: 'administration', 'admin-users': 'administration', branding: 'administration', thresholds: 'administration' };
export default function TenantActivityTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    let screen;
    try { screen = pathname === '/dashboard' ? screenForTab(new URLSearchParams(search).get('tab')) : screenForPath(pathname)?.key; }
    catch { return; }
    const reportPage = ['/report-builder', '/report-builder/template-selection', '/report-builder/pick-template', '/internal-report-preview', '/external-risk-report'].includes(pathname);
    const area = reportPage ? 'reports' : AREAS[screen];
    if (area) recordActivity(`${area}.opened`);
  }, [pathname, search]);
  return null;
}
